export default {
    navigationBarTitleText: '联系人信息',
  };
  